import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Shared/SignalExpression", function(app) {
  app.model("ParenTerminal", "ExpressionTerminal", {
    type: function() {
      return 'Paren';
    }
  });
});
